import { css } from '@emotion/react';

export const helperHorizontalScrollingContainer = css`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  &::after {
    content: '';
    flex-shrink: 0;
    padding-left: inherit;
  }
`;
